import { ValidaGtin } from "src/hook/Functions";
import yup from "src/validators/yup.Module";

export interface ProdutoCadastroDto {
  id: number;
  codigoProduto: string;
  codigoBarras: string;
  nome: string;
  descricao: string;
  valorUnitarioComercial: string;
  categoriaId: number;
  categoriaNome: string;
  codigoNCM: string;
  unidadeComercial: string;
}

export interface ProdutoCadastroProps {
  onSuccess?: (value: ProdutoCadastroDto) => void;
  onCancel?: () => void;
  initialValue?: Partial<ProdutoCadastroDto> | null;
}

const parseNumber = (value: string, originalValue: string) => {
  if (typeof originalValue === "string") {
    return parseFloat(originalValue.replace(".", "").replace(",", "."));
  }
  return value;
};

export const ProdutoCadastroSchema = yup.object().shape({
  codigoProduto: yup
    .string()
    .required("Código é obrigatório")
    .max(120, "Deve ter no máximo 60 caracteres."),
  codigoBarras: yup
    .string()
    .test("codigoBarras", "Código inválido.", function (value) {
      if (value !== "" && value !== undefined) {
        return ValidaGtin(value);
      } else {
        return true;
      }
    }),
  nome: yup
    .string()
    .required("Nome é obrigatório")
    .max(120, "Deve ter no máximo 120 caracteres."),
  valorUnitarioComercial: yup
    .number()
    .transform(parseNumber)
    .typeError("Informe o valor unitário comercial")
    .required("Informe o valor comercial unitário "),
  codigoNCM: yup
    .string()
    .required("Informe o código NCM")
    .length(8, "Código deve ter 8 números")
    .matches(/^\d{8}$/, "Código deve conter apenas números"),
  unidadeComercial: yup
    .string()
    .required("Informa unidade")
    .max(6, "Deve ter no máximo 6 caracteres."),
});
